import { useState } from "react";

/**
 * Stops the browser from pre-filling a field on page load while keeping the
 * saved-account picker: Chrome never autofills a readOnly input, so we hold the
 * field readOnly until the user actually interacts with it.
 */
export function useNoPrefill() {
  const [locked, setLocked] = useState(true);
  const unlock = () => setLocked(false);
  return {
    readOnly: locked,
    onFocus: unlock,
    onMouseDown: unlock,
    onTouchStart: unlock,
  };
}
